import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  Autocomplete,
  Box,
  DialogActions,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { submitSecondLevelAppeal } from "../../../store/e-appeal/actions";

import { showError } from "../../../app/toastify";
import { textCapitalized } from "../../common/components/Utils";
import WidgetUploadComponent from "../../common/components/WidgetUploadComponent";
import ErrorMessage from "../../common/components/ErrorMessage";
import ActionDialog from "../../common/components/ActionDialog";

const bannedWords = ['ok','okey','hey', 'test', 'posting...', 'hello', 'hmm', '...', 'hi'];

const maxLength = 500;
const minLength=100;
const SecondLevelAppealDialog = (props) => {
  const {
    user,
    loading,
    addNewAppealForm,
    setAddNewAppealForm,
    selectedAppeal,
    entitySectors,
    submitSecondLevelAppeal,
    setViewAppeal,
  } = props;

  const onClose = () => {
    setAddNewAppealForm(false);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    appealId: selectedAppeal ? selectedAppeal.id : 0,
    message: "",
    attachedFiles: [],
    tagInstitutions: [],
    appealTypeId: selectedAppeal?.appealTypeId || "",
    subject: selectedAppeal?.subject || "",
    employeePositionId: selectedAppeal?.employeePositionId || "",
    level: 2,
    caseId: selectedAppeal?.caseId || "",
  });

  const [errors, setErrors] = useState({
    fileHasError: false,
    messageHasError: false,
    messageBannedHasError: false,
    messageMinLengthHasError: false,
    messageMaxLengthHasError: false,
    hasError: false,
  });

  //console.log(entitySectors);
  const formValidator = () => {
    const error = {
      messageHasError: false,
      messageBannedHasError: false,
      messageMinLengthHasError: false,
      messageMaxLengthHasError: false,
      hasError: false,
    };

    if (!formData.message) {
      error.messageHasError = true;
      error.hasError = true;
    }
    if (
      !!formData.message &&
      bannedWords.includes(formData?.message?.trim()?.toLowerCase())
    ) {
      error.messageBannedHasError = true;
      error.hasError = true;
    }

    if (!!formData.message && formData?.message.length < minLength) {
      error.messageMinLengthHasError = true;
      error.hasError = true;
    }

    if (!!formData.message && formData?.message.length > maxLength) {
      error.messageMaxLengthHasError = true;
      error.hasError = true;
    }
    // if (!formData.attachedFiles.length) {
    //   error.fileHasError = true;
    //   error.hasError = true;
    // }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill out all required fields");
      return true;
    }
    return false;
  };

  const onSave = () => {
    if (!formValidator()) {
      const payload = new FormData();
      const keys = Object.keys(formData);
      for (const key of keys) {
        if (formData.hasOwnProperty(key)) {
          if (
            key === "attachedFiles" &&
            formData[key] &&
            !!formData[key].length
          )
            formData[key].forEach((row, i) => {
              payload.append(key, row.file);
            });
          else payload.append(`${key}`, `${formData[key]}`);
        }
      }
      submitSecondLevelAppeal(
        payload,
        setFormData,
        setIsSubmitting,
        setViewAppeal,
        onClose
      );
    }
  };
  const onUploadSuccess = (files) => {
    setErrors({ ...errors, fileHasError: false });
    setFormData({ ...formData, attachedFiles: files });
  };
  const onUploadErrors = (errors) => {
    if (errors) {
      setErrors({ ...errors, fileHasError: errors.fileHasError });
      showError(errors.message);
    }
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={addNewAppealForm}
        fullWidth
      >
        <DialogTitle className="text-primary">
          <div className="row">
            <div className="col-11">
              <h5
                style={{
                  // background: "rgba(0,99,207,.08)",
                  padding: "10px 25px",
                  borderRadius: "5px",
                  margin: "0 25px 32px 0",
                  width: "-moz-fit-content",
                  width: "fit-content",
                  color: "#0063cf",
                }}
              >
                {" "}
                Appeal to second level.
              </h5>
            </div>
            <div className="col-1">
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <span className="material-icons">close</span>
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-lg-12 mt-2">
              <TextField
                fullWidth
                multiline
                rows={4}
                size="small"
                name="message"
                label={`Please write your appeal message with at least ${minLength} and no more than ${maxLength} characters.`}
                variant="outlined"
                placeholder={`Please write your appeal message with at least ${minLength} and no more than ${maxLength} characters.`}
                value={formData.message}
               
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start"></InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  const message = e.target.value;
                  setFormData({
                    ...formData,
                    message,
                  });

                  setErrors({
                    ...errors,
                    messageHasError: false,
                  });
                }}
              />
              {!!formData.message.length && (
                <div className="float-right text-primary">
                  {formData.message.length}/{maxLength}
                </div>
              )}
              <ErrorMessage
                hasError={errors.messageHasError}
                message="Appeal message is required"
              />
              <ErrorMessage
                hasError={errors.messageBannedHasError}
                message="Appeal message contains a common or non-meaningful word."
              />
              <ErrorMessage
                hasError={errors.messageMinLengthHasError}
                message={
                  "Message is too short. Minimum " +
                  minLength +
                  " characters required."
                }
              />
              <ErrorMessage
                hasError={errors.messageMaxLengthHasError}
                message={
                  "Message is too long. Maximum " +
                  maxLength +
                  " characters allowed."
                }
              />
            </div>

            <div className="col-lg-12 mt-3">
              <WidgetUploadComponent
                onSuccess={onUploadSuccess}
                onErrors={onUploadErrors}
                multiple={true}
                acceptedFileSize="1074176"
                acceptedFileTypes="pdf"
                label="Upload supporting document *(pdf)"
              />
              {/* <ErrorMessage hasError={errors.fileHasError && !formData.attachedFiles.length} message='Supporting document is required' /> */}
            </div>
          </div>

          {isSubmitting && (
            <ActionDialog showAction={isSubmitting} action="Submitting" />
          )}
        </DialogContent>

        <DialogActions className="d-flex justify-content-center py-4">
          <button
            onClick={onSave}
            type="button"
            className="btn btn-primary  px-4"
            disabled={loading || isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, user, entitySectors }) => {
  return {
    loading,
    user,
    entitySectors,
  };
};
export default connect(mapStateToProps, {
  submitSecondLevelAppeal,
})(SecondLevelAppealDialog);
